import type { FeatureDefinitionGroup, FeatureExtractionVisibility } from '../feature-definition-types';

export type MarketingRelativePath = '/all-campaigns' | '/lead-engage' | '/drafts';

export const featureDefinition = {
  root: '/bulk',
  iconName: 'bulk-messaging',
  items: {
    '/all-campaigns': {
      label: 'All Campaigns',
      trackingId: 'nav-marketing-all-campaigns',
      description:
        'Lists all email and text marketing campaigns, both active and historical, with performance details for each.',
    },
    '/lead-engage': {
      label: 'Lead Connect',
      trackingId: 'nav-marketing-lead-engage',
      description: 'Shows marketing campaigns and generated leads for social media campaigns.',
    },
    '/drafts': {
      label: 'Drafts',
      trackingId: 'nav-marketing-drafts',
      description: 'Shows marketing campaigns still in draft form, allowing further edits before launch.',
    },
  },
} as const satisfies FeatureDefinitionGroup<'/bulk', 'bulk-messaging', MarketingRelativePath>;

export const featureExtractionVisibility = {
  itemShowClassifications: {
    '/lead-engage': 'runtime-conditional',
  },
} as const satisfies FeatureExtractionVisibility<MarketingRelativePath>;
